

  import {defineComponent} from 'vue';

  import HeaderComponent from '@/components/shared/HeaderComponent.vue';
  import NavigatorComponent from '@/components/shared/NavigatorComponent.vue';
  import PromotionBannerComponent from '@/components/main/PromotionBannerComponent.vue';
  import ThemeBannerComponent from '@/components/main/ThemeBannerComponent.vue';
  import ProductListComponent from '@/components/productList/ProductListComponent.vue';
  import ContentPlaceholderComponent from '@/components/contentPlaceholder/ContentPlaceholderComponent.vue';
  import ToTopComponent from '@/components/shared/TopButtonComponent.vue';

  import api from "@/api/backend-api";
  import router from "@/router/index";

  import Product from "@/domain/product/Product";
  import PromotionBanner from "@/domain/banner/PromotionBanner";
  import ThemeBanner from "@/domain/banner/ThemeBanner";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import {mapGetters} from "vuex";

  export default defineComponent({
    name: 'Home',
    components: {
      HeaderComponent,
      NavigatorComponent,
      PromotionBannerComponent,
      ThemeBannerComponent,
      ProductListComponent,
      ContentPlaceholderComponent,
      ToTopComponent
    },
    data() {
      return {
        promotionBanners: [] as Array<PromotionBanner>,
        themeBanners: [] as Array<ThemeBanner>,
        products : [] as Array<Product>,

        promotionBannerDataReceiverd: false,
        themeBannerDataReceiverd: false,

        isPromotionBannersLoaded: false,
        isThemeBannersLoaded: false,
        isProductsLoaded: false,
      }
    },
    mounted() {
      api.getPromotionBannerList()
      .then(response => {
        this.promotionBanners = response.data.result.map(promotionBanner => new PromotionBanner(promotionBanner));
        this.promotionBannerDataReceiverd = true;
      })
      .catch(error => {
        console.log("Error: " + error);
      })
      .finally(() => this.loadPromotionBannerImage());

      api.getThemeBannerList()
      .then(response => {
        this.themeBanners = response.data.result.map(banner => {
          const themeBanner = new ThemeBanner(banner);
          themeBanner.productList = themeBanner.productList.map(product => new Product(product));
          return themeBanner;
        });
        this.themeBannerDataReceiverd = true;
      })
      .catch(error => {
        console.log("Error: " + error);
      })
      .finally(() => this.loadThemeBannerImage());

      api.getBestProductList()
      .then(response => {
        this.products = response.data.result.map(product => new Product(product));
      })
      .catch(error => {
        console.log("Error: " + error);
      })
      .finally(() => this.loadProductImage());
    },
    methods: {
      moveProductsPage(): void {
        router.push(new NamedRouting('ProductListView'));
      },
      loadPromotionBannerImage(): void {
        this.isPromotionBannersLoaded = true;
      },
      loadThemeBannerImage(): void {
        this.isThemeBannersLoaded = true;
      },
      loadProductImage(): void {
        this.isProductsLoaded = true;
      },
    },
    computed: {
      isLoadingCompleted(): boolean {
        return this.isPromotionBannersLoaded && this.isThemeBannersLoaded && this.isProductsLoaded;
      },
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    }
  });
